export const FAQS = [

	{
		id: 4,
		catagory: 'General',
		questions: [{
				id: 16,
				qustion: "Why is insurance important ",
				anwser: "Insurance is essential because it protects you from financial losses that could otherwise be devastating. In addition, it provides peace of mind and helps you manage risks."
			},
			{
				id: 17,
				qustion: "What kind of insurance policies does Beema1 offer ",
				anwser: "Beema1 offers a variety of insurance policies, including car insurance, bike insurance, term insurance, and health insurance."
			},
			{
				id: 18,
				qustion: "What is insurance ",
				anwser: "Insurance is a service that protects against financial losses in case of unexpected events."
			},
			{
				id: 19,
				qustion: "How do I create an account on Beema1",
				anwser: "To create an account on Beema1, visit the website and click the 'Sign Up' button. Then, follow the instructions to provide your details and create a password."
			},
			{
				id: 29,
				qustion: "What are some common types of insurance",
				anwser: "Some common types of insurance include health, car, home, bike, property, life, and travel insurance."
			},
			{
				id: 30,
				qustion: "How Insurance Works",
				anwser: "Insurance is a legal contract between the policyholder and the insurance provider. The insurance policy contains all the details about the features, guidelines, and conditions under which the insurer will pay out the amount of insurance to the policyholder or their nominee in case any unfortunate event occurs. Insurance is a financial tool that helps you with financial coverage, ensuring financial protection for you and your family. The person who purchases the policy is known as the policyholder, who pays the premiums for the coverage available under the insurance policy. Any individual can avail of an insurance policy from any insurance company. Beema1 helps you compare and buy insurance plans through our online platform."
			},
			{
				id: 31,
				qustion: "What are some benefits of having insurance",
				anwser: "Some benefits of having insurance include protection against financial losses, peace of mind, and the ability to manage risks."
			},
			{
				id: 32,
				qustion: "Who needs insurance",
				anwser: "Everyone needs insurance, as unforeseen situations, circumstances, and events can happen to anyone at any time. Insurance offers financial security and helps you tackle risks, no matter whatever your situation is ."
			},
			{
				id: 33,
				qustion: "What is the first step in purchasing an insurance policy",
				anwser: "The first step in purchasing an insurance policy is researching different policies and checking their details to see which one meets your expectations."
			},
			{
				id: 34,
				qustion: "How do I determine what type of insurance policy I need",
				anwser: "You can determine the type of insurance policy you need by considering your risks and needs. For example, if you own a car, you may need car insurance, while if you have a family, you may need life insurance."
			},
			{
				id: 35,
				qustion: "What information must I provide when purchasing an insurance policy",
				anwser: "When purchasing an insurance policy, you must provide personal information such as your name, address, date of birth, and information about the item or items you are insuring. In the case of health insurance, you need to provide details of your current medical condition."
			},
			{
				id: 36,
				qustion: "How do I compare insurance policies",
				anwser: "You can compare insurance policies by looking at the coverage they provide, the premiums you will need to pay, and any deductibles or exclusions that may apply. This is where Beema1 can help you."
			},
			{
				id: 37,
				qustion: "Can I purchase insurance online",
				anwser: "Yes, you can buy insurance online. You can also buy insurance policies over the phone or in person."
			},
			{
				id: 38,
				qustion: "What should I consider when selecting an insurance provider",
				anwser: "When choosing an insurance company, you must contemplate factors such as their reputation, company policies, products available, claim settlement ratio, and customer service. Also, checking reviews and asking for recommendations from peers and family is equally essential."
			},
			{
				id: 44,
				qustion: "What is Beema1, and how does it work",
				anwser: "Beema1 is an online insurance platform that offers various insurance plans to customers. Furthermore, it offers an easy interface for customers to browse, equate, and buy insurance policies."
			},
			{
				id: 45,
				qustion: "How can I compare different insurance policies on Beema1",
				anwser: "Beema1 allows you to compare insurance policies by comparing the features, benefits, and premiums of different policies. As a result, you can easily select the policy that best suits your needs."
			},
			{
				id: 46,
				qustion: "Can I purchase insurance on Beema1 without speaking to an agent",
				anwser: "Yes, you can purchase insurance policies on Beema1 without speaking to an agent. The platform is designed to be user-friendly and easily predictable and understandable, allowing you to browse and purchase policies easily."
			},
			{
				id: 47,
				qustion: "Is my personal information secure on Beema1",
				anwser: "Yes, Beema1 shoulders the responsibility for the security of your personal information very seriously with utmost priority. The platform uses advanced security measures to protect your data and prevent unauthorized access."
			},
			{
				id: 48,
				qustion: "What types of insurance can I purchase on Beema1",
				anwser: "Beema1 offers a range of insurance policies, including term life insurance, health insurance, bike insurance, and motor insurance."
			}
		]

	},

	{
		id: 5,
		catagory: 'Car',
		subcategories: [{
				name: 'Genaral',
				questions: [{
						id: 1,
						qustion: 'Which type of car insurance is best',
						anwser: "Comprehensive insurance is often regarded as the top choice because it offers extensive coverage for your vehicle. However, if you're looking to insure an older car, opting for a third-party policy is a wise decision as it offers essential coverage required by law and is cost-effective."
					},
					{
						id: 2,
						qustion: 'Why should I buy car insurance',
						anwser: "There are several compelling reasons to have car insurance. Firstly, it fulfills the legal obligation of having at least third-party coverage. Additionally, an insurance policy safeguards you against financial responsibilities that may emerge from damage to a third party or your own vehicle in the event of an accident or other unforeseen circumstances."
					},
					{
						id: 3,
						qustion: 'How many types of insurance are there for a car',
						anwser: "There are mainly 3 types of car insurance policies available in India. Third party liability insurance, comprehensive insurance and own damage car insurance policy are the types of car insurance policies we are talking about. Third party liability covers the damages caused by the insured vehicles to others. Comprehensive insurance covers damage caused to both the parties involved in the accident including natural calamities and disasters. Own damage car insurance is a type of coverage that protects the insured’s vehicle from the damages caused because of natural disasters. It also covers for the losses incurred from man-made actions and incidents like thefts and riots and covers for the damages caused by the drivers who are uninsured."
					},
					{
						id: 4,
						qustion: 'How to understand what kind of insurance is suitable for my car',
						anwser: "At the time of choosing the best insurance plan for new car, take the following variables into consideration, such as coverage, premium rates, customer reviews, claim settlement ratio, and the comfort and convenience of the claims process. Beema1 stands out as the most favored choice for new car insurance, catering to all the criteria on the checklist."
					},
					{
						id: 5,
						qustion: "Why first car insurance is expensive",
						anwser: " As for a new car the IDV is always at the maximum at this point. Hence, a new car insurance is any day expensive than an old car. The value of the car depreciates with the age of the car reducing its IDV. Most of the people buy multiple add-ons which also hikes their premium amount."
					},
					{
						id: 6,
						qustion: "What is an endorsement in car insurance",
						anwser: "An authorization in car insurance is a revision or an addition made to the existing terms and conditions in the policy. Endorsements can be cited as riders which allows you to add, delete, modify any parts of the four-wheeler or terms and conditions under the four-wheeler insurance policy coverage. "
					},
					{
						id: 7,
						qustion: "What is an auto insurance/car insurance quote",
						anwser: "An auto insurance or car insurance quote is an estimate of the amount of money you will pay as premiums for a car insurance. It also itemizes the costs and the limits and restrictions of individual coverages. A detailed quote may also apply discounts.Requesting quotes is a significant part of shopping for car insurance that helps in making informed decisions, always requesting quotes from several insurance providers before finally purchasing a policy."
					},
					{
						id: 8,
						qustion: "How much is car insurance premium",
						anwser: "The rates of the premium for third-party car insurance price based on the engine capacity of the four-wheeler and is determined and fixed by the IRDAI. Any ways, the premium for standalone own-damage and comprehensive car insurance policies vary from car to car, based on certain variables such as car's MMV (Make, Model and Variant), RTO location, engine capacity, registration city, type of fuel."
					},
					{
						id: 9,
						qustion: "Can one car owner buy two policies for the same car",
						anwser: " No, one car owner cannot have two insurance policies for the same four-wheeler. A third-party plan and own damage insurance cover can be availed separately for a four-wheeler, in place of a comprehensive four-wheeler insurance."
					},
					{
						id: 10,
						qustion: "If new accessories are bought for my car, is it possible to insure those accessories in the middle of the insurance policy term",
						anwser: "The accessories can be insured that you purchased for your car at the time of renewing the policy but not in the middle of the insurance policy term."
					},
					{
						id: 11,
						qustion: "What is Insured Declared Value (IDV)",
						anwser: "IDV states the car’s current value and is the maximum amount that can be claimed in case of any theft or total loss of the vehicle."
					},
					{
						id: 12,
						qustion: "Is cashless auto insurance more expensive than standard policies",
						anwser: "A number of parameters, including the car's make, age, model, location, and driving record, might influence the expenses of cashless auto insurance. The surplus comfort it provides may cause it to be moderately costlier even though the contrast is not practically noticeable"
					},
					{
						id: 13,
						qustion: "Are online and offline car insurance policies being the same",
						anwser: "Yes, of course. Online and offline car insurance policies are the same. There’s a slight difference between both the concept. The online policy document is sent to your registered email address, while in case of offline policies, the policy document is sent to your residential address by post."
					},

				]
			},

			{
				name: 'Car Insurance Covers',
				questions: [{
						id: 1,
						qustion: 'Does car insurance cover the passengers',
						anwser: "Passengers sitting in the car are not covered by a standard car insurance policy. However, by availing a Passenger Cover at a much nominal premium, you can get reimbursed if the passenger sitting in the car suffers injury or passes away."
					},
					{
						id: 2,
						qustion: 'Is it possible to get medical cover for bodily injuries or demise of the passenger(s) commuted in the car Does it require to avail a separate car insurance policy cover for that purpose',
						anwser: "One can purchase a personal accident cover for passengers commuting in his/her car as an add-on cover. This insurance plan will cover the treatment expenses for accidental injuries nurtured by the passengers."
					},


					{
						id: 4,
						qustion: 'Does my car policy cover electrical fires',
						anwser: "The damage incurred due to electrical fire can be covered by the insurance if there is a provision in your policy."
					},

					{
						id: 5,
						qustion: "How many times a Roadside Assistance service can be claimed during a policy tenure",
						anwser: "Number of claims permitted for Roadside Assistance service during a policy period varies from one motor insurance company to another. For knowing more details about number claims allowed in a year, one can browse through the insurance policy document provided by the insurance company."
					},

					{
						id: 6,
						qustion: "Is it possible to take unlimited claims under Zero Dep",
						anwser: "Zero Dep claims vary from insurer to insurer. It can vary from two claims from an unlimited number of claims based on the decision of the insurance provider."
					},

					{
						id: 7,
						qustion: "Does car insurance cover scratches, dents and cosmetic damage",
						anwser: "Certainly, your car insurance will cover the cost to repair for dints, scrapes and maquillage damage, if the insured individual holds a comprehensive or standalone own-damage insurance policy."
					},

					{
						id: 8,
						qustion: "What is Garage Cash cover in car insurance",
						anwser: "A Garage Cash cover is an additional benefit that provides the owner of the car with a daily allowance to compensate the daily expenses of transportation if the car has to stay at the garage for long duration for the purpose of repairing."
					},

					{
						id: 9,
						qustion: "Are the damages caused due to a hit by a coconut or cricket bat covered by car insurance policy",
						anwser: "Given that, car insurance policy provides coverage for the manmade calamities where people might cause defects and damages to a car on purpose in riots, strikes, etc, therefore, damages caused due to coconut hit and a cricket bat hit can be covered."
					},

					{
						id: 10,
						qustion: "Is it possible to skip the (PA) Personal Accident cover under new car insurance",
						anwser: "The Personal Accident Cover (PA) can be skipped under your new car insurance policy if you already have it under your existing motor policy. If you don’t have it, the you will have to purchase it, as buying PA covers are mandatory in India."
					},


					{
						id: 11,
						qustion: "Does third-party insurance cover theft and fire breakout",
						anwser: "Generally, theft and damages happening to the insured car because of fire breakouts are not covered under third-party car insurance plans. However, customized third-party plans are offered by some of the insurance providers that offer coverage for theft and fire."
					},

					{
						id: 12,
						qustion: "Is the engine covered in zero dep",
						anwser: "Any kind of damage to the engine of the vehicle insured is not covered under the zero-dep cover. For this, one must purchase an engine protect add-on cover separately from your car policy."
					},


				]
			},
			{
				name: 'Car Insurance Claims',
				questions: [{
						id: 1,
						qustion: 'Advice on car insurance claim rejections',
						anwser: "Never miss to carry your valid car driving license along with you while driving as your claim will be rejected if you do not carry a DL with you if you get in an accident."
					},

					{
						id: 2,
						qustion: 'How to write an official car insurance claim letter',
						anwser: " To write an official car insurance claim letter in India needs a standardized and a detailed approach to ensure the claim is appropriately established and processed. Learn more to know how to write an official car insurance claim letter:"
					},


					{
						id: 4,
						qustion: 'What role does a surveyor play in the claim settlement process',
						anwser: "When you raise a claim with an insurance company, the insurer sends a surveyor to direct and conduct an inspection to assess and analyze understand the limitations of damage incurred by your car. The surveyor submits a damage assessment report to the insurance provider for the processing of claim settlement."
					},

					{
						id: 5,
						qustion: "How many times claims can be raised in a year ",
						anwser: "Unlimited number of claims are allowed in an entire year under an insurance policy."
					},

					{
						id: 6,
						qustion: "Is it possible to file a claim with the car insurance company for an indentation at the backside of my car Will the premium shoot up",
						anwser: "You can claim for the indentation at the backside of your car but it can discontinue any accrued No Claim Bonus (NCB) benefit, which can increase and magnify the premium of your next policy year. Therefore, it is recommended to bear small compensation on your own to save NCB and avoid the increase of premium."
					},


					{
						id: 7,
						qustion: "What document should be submitted to avail my No Claim Bonus",
						anwser: "If you decide to renew the car insurance policy with your own insurance provider, then only your policy document will be required to avail No Claim Bonus. But, if you are renewing your insurance plan with a different insurance company for your current car, you will need your previous year’s policy document or the notice of renewal which states the NCB you are qualified for."
					},

					{
						id: 8,
						qustion: " If my car insurance policy expires. Will my NCB be retained",
						anwser: "No, if your car insurance policy expires, then the entitled No Claim Bonus (NCB) will be cancelled and you will have to renew your insurance plan on the standard policy premium."
					},

					{
						id: 9,
						qustion: "Are the damages caused due to a hit by a coconut or cricket bat covered by car insurance policy",
						anwser: "Given that, car insurance policy provides coverage for the manmade calamities where people might cause defects and damages to a car on purpose in riots, strikes, etc, therefore, damages caused due to coconut hit and a cricket bat hit can be covered."
					},

					{
						id: 10,
						qustion: "Do a FIR is required to raise a car insurance claim",
						anwser: "One must register a FIR in case of any road accident, if the consequences are any kind of physical harms leading ‘bodily injuries’, incapacity, or sudden demise of third party. Furthermore, an FIR becomes a mandatory requisite if the car gets stolen. In such scenarios, you need to submit one copy of the FIR to your insurer and you need to keep a copy for yourself while applying for the claim."
					},
					{
						id: 11,
						qustion: "What is the insurance claim procedure in case of car theft",
						anwser: "When you come to know that your car has been robbed, the first step one should take is to enlist a First Information Report (FIR) at a local police station. You will be given a copy of the FIR that you will need for filing the claim. After registering an FIR, you must raise an insurance claim and can inform the insurance company regarding the theft. You need to inform your RTO about the car theft. You need to fill up few official forms. Thereafter, those forms will be signed by the RTO officer. With the appropriately signed forms, the RTO will hand-over the transfer papers to be submitted to the insurance provider. You should submit the required significant documents to your insurance company including the No Trace Report, that’s given by the police in case they cannot find the car for a particularly precise duration. This document is majorly compulsory to get the claim sanctioned by your insurance company."
					},
					{
						id: 12,
						qustion: "How many times the Roadside Assistance service can be availed during a policy year",
						anwser: "The number of claims permitted on the roadside assistance service during a policy tenure varies from one motor insurer to another. You can browse through your policy document to know the actual number claims allowed in a year."
					},
				]
			},
			{
				name: 'Multiple Questions Based On Car Insurance',
				questions: [{
						id: 1,
						qustion: 'How to find my car insurance policy number',
						anwser: "Car insurance policy number is a unique 8 to 10digit number provided by the insurance provider for the recognition of your insurance account. It is written on the insurance card or statements issued by the insurer. The number remains the same as long as the policy is active with the respective insurance company."
					},

					{
						id: 2,
						qustion: ' What if the car insurance policy gets expired',
						anwser: " Generally, car insurance has a validity period, post which you need to renew the insurance to continue enjoying the policy benefits. If you somehow miss to get your plan renewed before the expiry date, you can still renew the policy till the next 90 days from the date of expiry. After the expiry of this 90-days period, it is not possible to renew the car insurance. In such a scenario, you need to purchase a new policy."
					},


					{
						id: 4,
						qustion: 'What do you understand by depreciation in car insurance',
						anwser: "Depreciation related to car insurance refers to the loss of the insured car’s value along with time due to wear and tear. The depreciation rate plays a significant role in a policy as insurance companies consider, based on the age of the car, to decide and regulate the value they agree to provide for your car."
					},

					{
						id: 5,
						qustion: "What are the factors that insurance providers value and consider to accept car insurance applications",
						anwser: "When you apply for a car insurance policy, the insurer asks you to reveal different pertinent information requested on the insurance application. Many insurance companies consider your credit history, age, your criminal record, and few other aspects for accepting or cancelling your application."
					},

					{
						id: 6,
						qustion: "Where can I use services for cashless claims",
						anwser: "The network garages those are empaneled with the insurance provider are the locations where cashless claim services can be availed."
					},


					{
						id: 7,
						qustion: "How voluntary deductible is defined in car insurance",
						anwser: "A voluntary deductible is defined as the share of the insurance claim that the policyholders agree to pay on their own. If you choose this deductible, the premium of your policy will decrease."
					},

					{
						id: 8,
						qustion: "What needs to be done if there’s any error or inaccuracy in my car policy document",
						anwser: " If there is any mistake or inaccurate detail entered in the car insurance policy document, it can very much be rectified online or offline, depending on the provisions stated by the insurer. The changes in the policy document may be done online or through phone calls or via email or by visiting the nearest branch of your insurer."
					},


					{
						id: 9,
						qustion: "When should I report to the police",
						anwser: "When your car gets stolen or meets with an accident, it should be reported to the police as soon as possible and file an FIR (First Information Report). All insurance companies ask for an FIR copy for initiating the settlement process."
					},

					{
						id: 10,
						qustion: "What happens to the car insurance policy if the car is sold out",
						anwser: "As per the Motor Vehicle Act, 1988, when the car is sold out, the owner of the car is responsible to transfer existing car insurance policy in the name of the new owner of the car within 14 days of the sale of the car. Also, one can cancel the policy by getting in touch with the insurer. The insurance provider will prorate the payment and pay back the remaining amount for the month or overall policy term."
					},

					{
						id: 11,
						qustion: "How much time it takes to purchase or renew a car insurance policy online",
						anwser: " If the policy owner has the data and all the detailed information ready, it will not take more than few minutes to purchase or renew a car insurance policy online specifically at popular and well-known insurance portals like Beema1"
					},

					{
						id: 12,
						qustion: "What is the cost of car insurance policy renewal",
						anwser: "There is no fixed expense for renewing a car insurance plan as it is based on various components such as policy type and add-ons in policy, modifications in the car, and so on."
					},

					{
						id: 13,
						qustion: "If I fit CNG or LPG kit in my car, is it important to inform the insurance provider",
						anwser: "You must notify your vehicle insurer about the change in your car's fuel type to CNG as soon as you receive the kit equipped in your car. One is not supposed to wait for car insurance policy renewal to update your insurance company regarding the modification so that the kit can be covered under the plan."
					},

					{
						id: 14,
						qustion: " What happens to the car insurance policy if the car changes the city in case the car owner drives to another city",
						anwser: "If you change your city, you should update your insurance provider as your insurance premium might get effected as the traffic density in a metro city is higher than tier 2 cities, for which more accidents may occur to cover which higher premium to be paid."
					},

					{
						id: 15,
						qustion: "Is it possible to insure cars after 15 years",
						anwser: "Yes, cars can be insured after 15 years with the third-party car insurance plan as everyone carries the liability only cover as a compulsion as per the Motor Vehicles Act, 1988. Any which ways, insurance with own-damage cover varies from insurance company to insurance company."
					},
					{
						id: 16,
						qustion: "How to calculate car insurance premium",
						anwser: "Use Beema1 car insurance premium calculator: This car insurance premium calculator is an easy to operate online tool to assist and guide the   car owners to conveniently calculate and decide their insurance premium depending on the inputs like car type, brand, year of purchase, registered city, etc. You only need to enter the details, click on the Calculate Premium option, select the add-on options and you will receive the most pocket-friendly as well as useful premium quotes for you."
					},

					{
						id: 17,
						qustion: "What is the loading period in a policy",
						anwser: "Loading is a supplementary premium amount applied by the insurance providers in addition to the base premium for a car insurance policy. It is an additional cost incorporated into the insurance policy to provide coverage or losses that are higher than expected amount arised from insuring a person who is prone to a type of risk"
					},

					{
						id: 18,
						qustion: "Does the car model affect the cost of car insurance",
						anwser: "The premium of car insurance will change for different models of a car from the same manufacturer, because every model is uniquely made and have quite expensive parts than its countermodels."
					},

					{
						id: 19,
						qustion: "Are there any provisions of special discounts on car insurance for people happening disabilities",
						anwser: "Yes, certainly. Some car insurers offer discounts up to 50% of the premium amount for those with lesser physical disabilities if the car or vehicle is particularly modified in a way, that it can be used for the physically disabled."
					},
					{
						id: 20,
						qustion: "What do you mean by a cover note in car insurance",
						anwser: "When we talk about car insurance, a cover note is just a temporary certificate of insurance issued by the insurance provider before the issuance of a policy, post the submission of a duly filled in proposal form by the insured person and has completely made the payment."
					},

					{
						id: 21,
						qustion: "Why car insurance premiums vary from company to company",
						anwser: "The rates of car insurance differ from one insurance company to another as every insurance company uses an exclusive formula to assess the risk and decide the amount of premium and claim that will be paid during the policy year."
					},
					{
						id: 22,
						qustion: "Can the car insurance premium be paid in instalments",
						anwser: "No, there is no such provision to make instalment payments in regards to car insurance premium."
					},

					{
						id: 23,
						qustion: "Why does every year car insurance premiums increase",
						anwser: "Every year car insurance premiums increase as because the third-party insurance premium rates are increased by IRDAI. Considering the fact that third party cover is mandatory for all car owners, hence, it impacts the amount of the car insurance premiums. After analyzing the loss ratios of car insurance providers and the total number of claims placed by policyholders, the IRDAI states the third-party premium rates for the next financial year."
					},
					{
						id: 24,
						qustion: "How Hypothecation can be added or removed in my car insurance policy",
						anwser: "To add hypothecation to the car insurance, one will have to submit a letter from the bank or an endorsed copy of RC, form 34, PUC certificate, address proof and PAN card of the car owner, valid car insurance policy and receipt of the fee paid for the hypothecation by the RTO. On the other hand, to remove the hypothecation from your insurance, you will have to submit NOC from the lender to the insurance company in addition to form 35, a valid four-wheeler insurance plan, and PUCC."
					},
					{
						id: 25,
						qustion: "How to get a duplicate copy of my car insurance policy online",
						anwser: "You can receive a duplicate copy of your car insurance in 3 simple steps: Step 1: Visit the insurance website and select the car insurance tab. Step 2: Log in to your account by inputing the needful details like insurance policy number, mobile number, etc. Step 3: You can download the insurance policy copy effortlessly from the accessible link. In case of any issues or if you face any kind of obstacles, one can connect with the customer by contacting the customer care team of the insurance provider and request for a duplicate four-wheeler insurance policy copy and it will be sent."
					},

					{
						id: 26,
						qustion: "How the car insurance premium can be reduced",
						anwser: "Add-ons are additional benefits that increase your policy. Enhancement includes the followings: To maintain a decent driving record. 2:Settling for higher voluntary deductibles. 3:Anti-theft devices need to get installed. 4:Instead of filing small claims focus to retain your No Claim Bonus. 5:Find the most affordable premium by comparing policies online"
					},





				]
			},
		]
	},
	{
		id: 4,
		catagory: 'Bike',
		questions: [{
				id: 40,
				qustion: "A two-wheeler insurance policy: what is it",
				anwser: "A two-wheeler insurance policy is a contract between an insurance provider and a bike owner that states that, depending on the selected policy, the insurance provider would pay for any losses or damages incurred by the covered bike due to an accident, theft, fire, etc. The contract between the insured and the insurer typically lasts one year and must be renewed annually."
			},
			{
				id: 54,
				qustion: "What does Beema1's bike insurance policy cover",
				anwser: "Beema1's bike insurance policy covers damages to your bike, liability for bodily injury or property damage to the third-party, and medical expenses for you and your passengers."
			},
			{
				id: 55,
				qustion: "What sorts of bike insurance policies are there",
				anwser: "Three different types of bike insurance policies are available on Beema1: own standalone damage, third party, and comprehensive."
			},
			{
				id: 56,
				qustion: "What is the cost of the various bike insurance policies",
				anwser: "Different bike insurance policies have various premium costs. The IRDAI determines the third-party policy's premium, which varies according to the bike's engine size. However, the cost of the comprehensive and own-damage insurance premium varies from bike to bike depending on the bike's brand, model, and version, as well as its engine size and fuel type. So, check out all the options at Beema1 and find a suitable option."
			},
			{
				id: 57,
				qustion: "Does India have a law requiring bike insurance",
				anwser: "According to the Motor Vehicles Act of India, every bike owner is obliged to have at least a third-party bike insurance coverage."
			},
			{
				id: 58,
				qustion: "Can the insurance on a bike be transferred to a new owner",
				anwser: "In the event of selling a second-hand bike, the insurance coverage can be shifted from the preceding owner to the new owner. The motorcycle needs to be transferred to the new insurance company."
			},
			{
				id: 59,
				qustion: "After 15 years, are motorcycles still insured",
				anwser: "At 15 years of age, old motorcycles can still be insured. They are eligible for coverage under the third-party bike insurance plan because it is required. But there are differences among insurers regarding own-damage coverage."
			},
			{
				id: 60,
				qustion: "What is the rule of bike insurance in India",
				anwser: "In India, if you buy a new bike, two-wheeler insurance is mandatory for a 5+1 year. This means a 5-year third-party two-wheeler plan + 1 year own-damage two-wheeler plan."
			},
			{
				id: 61,
				qustion: "How to save on bike insurance premiums",
				anwser: "Ride your bike cautiously and maintain a clean driving record. Select a higher number of deductibles. Opt for the add-ons which are truly essential. Check your No Claim Bonus (NCB) before renewing the policy. Do not ignore the traffic norms. Compare the policies online before you purchase. Avoid raising claims for trivial damages. Avail long-term policies and opt for the best discounts."
			},

			{
				id: 63,
				qustion: "Which insurance is the best for an old two-wheeler",
				anwser: "Whether you have an old or a new bike, buying either the compulsory third-party policy or the comprehensive insurance policy, to cover / compensate the damages against your bike or yourself is important."
			},

			{
				id: 65,
				qustion: "What is an endorsement in bike insurance policy",
				anwser: "An endorsement is an official written document which assists to ratify the current terms and conditions of an existing bike insurance policy. For an example, if an individual wish to increase the coverage or may be add on the riders, then these appropriate changes may be done through a process named as endorsement."
			},
			{
				id: 66,
				qustion: "What is the insured's declared value IDV in bike insurance",
				anwser: "IDV is the insured declared value of the bike, which attributes to the maximum value of the vehicle that can be covered by the insurer in case of total loss or theft."
			},
			{
				id: 68,
				qustion: "What is full insurance in a bike",
				anwser: "In terms of bike insurance, a full insurance is referred to a comprehensive bike policy that offers a complete coverage for your insured two-wheeler against fire, theft, burglary, accidents, third-party liabilities, etc."
			},
			{
				id: 69,
				qustion: "What could be the cost of a bike insurance",
				anwser: "Depending upon the engine capacity of your two-wheeler, IRDAI determines a third-party bike insurance cost. Any which ways, a comprehensive bike insurance policy premium depends on various factors, such as model, make, variant, location and year of registration, the driving records of the policy holder, add-ons, etc."
			},
	
			{
				id: 71,
				qustion: "What is the validity of a two-wheeler insurance policy in India",
				anwser: "If you buy a brand-new bike, you have to mandatorily purchase a 5+1 years bike, the effectiveness will be of 3 years."
			},
			{
				id: 72,
				qustion: "Which insurance is the best for an old bike",
				anwser: "Whether, the two-wheeler is old or new, purchasing either the compulsory third-party policy or the comprehensive insurance policy to cover the damages against your two-wheeler or yourself is crucial."
			},
			

				{
				  id: 74,
				  qustion: "Is a new vehicle replaceable in my current bike insurance policy",
				  anwser: "Yes, you can easily transfer or replace your insurance coverage plan from your existing two-wheeler to your new two-wheeler by filling out the proposal form. The insurer has to re-look at the new bike’s specifications and calculate the IDV all over again according to the market value of the new bike."
				},
		
				{
				  id: 76,
				  qustion: "Is it safe to purchase/renew a bike insurance policy online",
				  anwser: "Yes, buying and renewing bike insurance online is 100% safe and transparent. To get the best results and benefits of online purchases, it is recommended to purchase from the official websites."
				},
				{
				  id: 77,
				  qustion: "What is an endorsement in bike insurance policy",
				  anwser: "An endorsement is an official written document which assists to ratify the current terms and conditions of an existing bike insurance policy. For example, if an individual wishes to increase the coverage or maybe add on the riders, then these appropriate changes may be done through a process named as endorsement."
				},
			
				{
				  id: 79,
				  qustion: "What is zero depreciation in bike insurance",
				  anwser: "Zero depreciation or nil depreciation in terms of bike insurance is much pertinent as it assures that a policyholder receives the total claim settlement without any amount deducted on the basis of depreciation. Depreciation results in a reduction in the value of your two-wheeler over time due to normal wear and tear."
				},
				{
				  id: 80,
				  qustion: "What is a full insurance in a bike",
				  anwser: "In terms of bike insurance, a full insurance is referred to as a comprehensive bike policy that offers complete coverage for your insured two-wheeler against fire, theft, burglary, accidents, third-party liabilities, etc."
				},

				{
				  id: 82,
				  qustion: "Is bike insurance mandatory in India",
				  anwser: "Yes, based on the Motor Vehicle Act 1988, all the two-wheeler owners in India must hold a third-party bike insurance policy mandatorily."
				},
		
				{
				  id: 84,
				  qustion: "Which insurance is the best for an old bike",
				  anwser: "Whether the two-wheeler is old or new, purchasing either the compulsory third-party policy or the comprehensive insurance policy to cover the damages against your two-wheeler or yourself is crucial."
				}
			  
			  
		
		]

	},
	{
		id: 4,
		catagory: 'Health',
		questions: [{
				id: 41,
				qustion: "What age is ideal for purchasing health insurance",
				anwser: "The best age to purchase health insurance is one that works for you. But to keep your premium low, buying it as soon as possible is advised. Because you are less likely to experience health problems when you are young compared to someone in their mid-50s or 60s, who is more susceptible to serious illnesses, the earlier you purchase health insurance policy for yourself, the lower the premium you will have to pay."
			},
			{
				id: 49,
				qustion: "Is a medical exam required to purchase health insurance",
				anwser: "Getting health insurance coverage does not need getting a medical exam. However, if applicants are older than 45 years, most Indian health insurance companies demand medical test results. Other medical tests may be necessary depending on the applicant's age and the insurer's requirements."
			},
			{
				id: 50,
				qustion: "What is the sum insured by health insurance",
				anwser: "The 'sum insured' describes the maximum sum an insurance company will pay a policyholder if he/she files a claim for a medical condition or accidental injury. It also goes by the name 'maximum coverage' in health insurance."
			},
			{
				id: 51,
				qustion: "How do I add my family to my present medical insurance",
				anwser: "You can include more family members while renewing or purchasing a health insurance policy. As long as you adhere to the terms and conditions of the family health insurance plan, you, your spouse, your dependent children, your parents, and your parents-in-law may all be covered."
			},
			{
				id: 52,
				qustion: "What if I already have health insurance but want to raise the amount insured",
				anwser: "You can raise the amount insured under your current policy when your health insurance coverage is renewed. If the sum insured under your existing policy cannot be increased, then you can anyway purchase a top-up plan to increase the coverage."
			},
			{
				id: 53,
				qustion: "What does Beema1's health insurance policy cover",
				anwser: "Beema1's health insurance policy covers medical expenses, like doctor appointments, hospital admission, prescription drugs, and coverage for preventive care and wellness programs."
			},
			{
				id: 88,
				qustion: "What is cashless claim settlement",
				anwser: "The cashless claim settlement facility allows the policyholder to avail treatment benefits at the network hospital without worrying about the expenses. The bill in cashless cases are settled directly between the insurance provider and the network hospital. However, the policyholder only pays for expenses that aren’t a part of or covered under the cashless facility. Yes, the policyholder can use this facility at any of the network hospitals of the insurer that provides cashless claim settlement facilities. Never forget to note down the names of the network hospitals for availing cashless claim settlement because the patient needs to get admitted in a network hospital. Every insurance company has their own set of network hospitals. it is very essential for every policyholder to have the information and knowledge about the listed hospitals in the company’s network as it’s always preferred for an individual to choose the location and area according their convenience. Most suitably providing cashless facility."
			},
			{
				id: 89,
				qustion: "Does your health insurance policy cover you all across India",
				anwser: "You really cannot anticipate when a medical emergency will occur. Hence, it is wise to be alert and cautious of the territorial limitations of the claim settlement in the policy in advance. Health insurance policies provide coverage across India; however, it is best to clarify all your queries about the same before confirming your decision regarding purchasing your health insurance plan. Stay informed that there are also some medical insurance plans that provide international health insurance coverage as well."
			},
			{
				id: 90,
				qustion: "Are pre-existing diseases covered under the health insurance policy",
				anwser: "Pre-existing diseases is something that varies from policy to policy. A policy offering cover for a pre-existing condition will get tagged along with a certain waiting period applicable on the coverage. Without fail, find out the waiting period for your pre-existing diseases and how early you are eligible to be covered. To conclude, having a clear picture of whether your pre-existing condition is not covered in the interim or is it entirely excluded from the option of coverage is must before purchasing the policy."
			},
			{
				id: 91,
				qustion: "Whom to contact in case any emergency hospitalization happens",
				anwser: "Medical exigencies ask for quick surveillance and awareness, that’s why it is recommended that you concentrate on taking the patient to the nearest network hospital for hospitalization. After you get admitted the family members of the patient must contact the insurance provider or the Third-Party Administration (TPA) to inform about the hospitalization and get the best possible guidance related to claim settlement procedure."
			},
			{
				id: 92,
				qustion: "Willing to claim for treatments availed at a non-network hospital",
				anwser: "Sometime, we are left with no option but to get the insured policyholder hospitalized at a non-network hospital under an emergency situation and circumstances. In such occurrences, one can apply for a reimbursement claim post completion of treatment. In such a case, the insured gets treated, pay for the treatment availed, and then file for a reimbursement claim. All expenses are covered under the policy coverage, except for ones which doesn’t fall under the category."
			},
			{
				id: 93,
				qustion: "What about the proper documentation to file a health insurance claim",
				anwser: "Documents are submitted at the time of filing a claim on your health insurance policy It is mandatory. Most commonly, a health insurance provider ask the policyholders to provide the ID proof of the insured individual, and the health card issued by the insurance company. The invoices, other necessary medical documents. bills and invoices for the treatment availed are equally essential In case of cashless hospitalization, the insured individual also submits a pre-authorization form to the TPA. For availing reimbursement facility, policyholder is required to provide relevant bills plus the other valid documents for the claimed amount to the TPA."
			}
		]


	},
	{
		id: 4,
		catagory: 'Term',
		questions: [{
				id: 43,
				qustion: "What does Beema1's term insurance policy cover",
				anwser: "Term insurance extends coverage for a pre-set period and pays a death benefit to your beneficiaries if you pass away during the term. It does not accumulate cash value or give any other benefits beyond the death benefit."
			},
			{
				id: 64,
				qustion: "What happens if the policyholder lives beyond the period",
				anwser: "Unless the return of premium benefit is included in the policy, the policyholder does not receive any benefits or returns if he survives the term policy tenure."
			},
			{
				id: 65,
				qustion: "Does Term Insurance Cover Covid-19",
				anwser: "Term life insurance policies also cover Covid-19 death claims. Some insurance plans also pay for hospital expenses."
			},
			{
				id: 66,
				qustion: "Why is term insurance crucial",
				anwser: "Term insurance extends financial well-being for the family in case of the policyholder's untimely death. You can also choose to get coverage for serious illnesses or accidental death. Moreover, you can get more coverage for less money with a term life insurance plan."
			},
			{
				id: 67,
				qustion: "How do I choose the right term insurance",
				anwser: "Before choosing the appropriate term insurance plan, determine your goals, number of dependants, financial commitments, etc. You must select one that provides the highest death benefit at a cheap premium and within your financial affordability."
			},
			{
				id: 68,
				qustion: "What size term insurance policy should I buy",
				anwser: "The coverage level relies on various variables, including the number of dependants in the family, investment objectives, budget, and the lifestyle you hope to provide to your family. You can use the method to have a sum assured that is 10 times your yearly income to determine the minimum term policy coverage you require."
			},
			{
				id: 94,
				qustion: "How beneficial is a term insurance premium calculator",
				anwser: "The term insurance premium calculator helps you to tailor and modify your term plan according to your requirements. This is a flexibility provided to you to personalize your term insurance plan by choosing a life cover that is suitable for you as per your needs. You have the options to enhance your plan by selecting riders of your choice, premium payment term you are looking for, and the payout method as per your financial planning. Term insurance premium calculator can efficiently calculate and generate a quote in couple of minutes that would be helpful for you. And this service is available with absolutely no cost."
			},
			{
				id: 95,
				qustion: "Who needs to purchase a term plan",
				anwser: "Young individuals and parents need to avail term plans. The premium of term insurance increases along with your age. Therefore, its advisable to avail a term plan to secure your savings and family in your sudden absence. An individual should avail a term insurance plan at a very young age, once he/she starts earning and when an individual doesn’t have any financial liabilities. Because, you can avail for your term plan at very lower premium rates and the rates will not tend to increase over time. If you have dependents in your family, like children or old aged parents, then you should definitely opt for a term plan. Newly married couples can opt for term plan to fulfill their dreams. In case you are indebted with any kind of loans, then the lumpsum death benefit from your term plan will help your family members to unburden the financial loads by repaying back for your financial borrowings in your absence. In case of any unfortunate events like death, the liability of paying the outstanding loans should not be shouldered by your family members."
			},
			{
				id: 96,
				qustion: "What is the payout option in a term insurance that an individual should opt for",
				anwser: "One should assess and appraise one’s own lifestyle before choosing a payout option while buying term insurance plan. This evaluation holds immense importance in your decision making. This provides you a fair idea about the total sum of money that your loved ones would need in your absence, in case any unfortunate incidents happen. This shall replace the flow of income in certain intervals when you are not around. The form of payouts are as follows:\nIncreasing Monthly Income – To keep up the pace with the inflating inflation in Indian medical sectors, this increasing monthly income payout policy has been designed in a way that your nominee will be receiving monthly payout that shall increase by 10% every year for the next 10 years. This regular flow of income will help your nominee in planning and managing the finance.\nMonthly Income – As chosen at the inception of our term life policy, your monthly income plan shall provide you with monthly monetary support for a period of 10 years/20 years or 30 years as a monthly income that may also help in paying pocket-friendly premiums toward any financial instruments.\nLumpsum Payout – It is a one-time lumpsum payout paid to your nominee in one go. This option is the most preferred and mostly availed option that might also help you to repay your home loan EMIs and get rid of your financial backlogs plan fully. This payout option could be a convenient option to invest in any financial instruments that might reap in higher financial benefits in future. This corpus could be utilized in a customized way that’s most beneficial for your nominee.\nLumpsum + Monthly Income – You can choose to receive your life cover benefits in two parts. In case of any sudden demise, the nominee will receive one payout in lumpsum and the rest will be received in the form of monthly income for a period of 10 years/20 years and 30 years which should be decided at the inception itself. It helps in meeting up immediate needs plus supports your family to meet up regular expenses as well."
			}
		]


	},

];